import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Units } from 'src/app/floor-management/floor-management-interface';
import { FloorManagementService } from 'src/app/floor-management/floor-management.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import { DeviceAddedComponent } from './device-added/device-added.component';
import { DeviceInformationComponent } from './device-information/device-information.component';
import { DeviceManagementService } from './device-management.service';
import { DeviceNameComponent } from './device-name/device-name.component';
import { DeviceTypeComponent } from './device-type/device-type.component';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-device-management',
  templateUrl: './device-management.component.html',
  styleUrls: ['./device-management.component.scss'],
})
export class DeviceManagementComponent implements OnInit {
  formGroup!: FormGroup;
  accessPointId!: string;

  subscription: Subscription | undefined;
  readonly LANG_CONST = LANG_CONST;
  sharedData?: ISharedData;
  stepper = 1;
  addDeviceNameComponent: number = parseInt(
    CONSTANTS.ADD_DEVICE_NAME_COMPONENT
  );
  deviceInformationComponent: number = parseInt(
    CONSTANTS.DEVICE_INFORMATION_COMPONENT
  );
  deviceAddComponent: number = parseInt(CONSTANTS.DEVICE_ADD_COMPONENT);

  @ViewChild(DeviceNameComponent) deviceNameRefComponent:
    | DeviceNameComponent
    | undefined;
  @ViewChild(DeviceTypeComponent) deviceTypeRefComponent:
    | DeviceTypeComponent
    | undefined;
  @ViewChild(DeviceInformationComponent) deviceInformationRefComponent:
    | DeviceInformationComponent
    | undefined;
  @ViewChild(DeviceAddedComponent) deviceAddedRefComponent:
    | DeviceAddedComponent
    | undefined;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DeviceManagementComponent>,
    private deviceManagement: DeviceManagementService,
    @Inject(MAT_DIALOG_DATA) data: any,
    private notificationService: NotificationService,
    private floorManagementService: FloorManagementService,
    private sharedDataService: SharedDataService,
    private stateManagementService: StateManagementService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {
    this.accessPointId = data.accessPointId;
  }

  get formInstance() {
    return this.formGroup?.controls;
  }

  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.createControls();
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
      }
    );
  }

  /**
   * @description Create all child component into parents
   */
  createControls(): void {
    this.formGroup = this.fb.group({
      deviceNameDetails: this.fb.group({
        deviceName: [
          '',
          MFValidators.compose([
            MFValidators.required,
            MFValidators.whitespace,
            MFValidators.maxLength(50),
            MFValidators.requiredSpecialCharForLock,
          ]),
        ],
      }),
      deviceSerialDetails: this.fb.group({
        serialNumber: [
          '',
          MFValidators.compose([
            MFValidators.required,
            MFValidators.macAddress,
            MFValidators.whitespace,
            MFValidators.maxLength(50),
          ]),
        ],
      }),
    });
  }

  submitToParent(): void {
    this.deviceManagement
      .addPartnerDevice(
        this.formGroup?.value.deviceNameDetails.deviceName,
        this.formGroup?.value?.deviceSerialDetails.serialNumber,
        this.accessPointId,
        CONSTANTS.PARTNER_DEVICE_CONTROLLER
      )
      .subscribe({
        next: (res: any) => {
          if (res && res.deviceId) {
            this.stepper = this.deviceAddComponent;
            this.notificationService.showSuccess(
              this.translate.instant('DEVICE_ADDED_SUCCESSFULLY')
            );
            this.getAllPartnerDevices();
            this.updateNameOfAccessPoint();
          }
        },
        error: (err: Error) => {
          this.notificationService.showError(err?.message);
        },
      });
  }

  /**
   * @description: #updateNameOfAccessPoint function will update the Names of access point on successfull creation of a device.
   * @param none
   * @output { none }
   */
  updateNameOfAccessPoint(): void {
    this.sharedDataService.setSelectedAccessPoint({
      accessPointId: this.sharedData?.selectedAccessPoint?.accessPointId,
      accessPointName: this.formGroup?.value.deviceNameDetails.deviceName,
    });
    const floorId: any = this.sharedData?.selectedFloor?.floorId;
    const units: Units = this.stateManagementService.getUnits(floorId);
    units?.forEach((currentUnit) => {
      if (
        currentUnit?.accessPointId ===
        this.sharedData?.selectedAccessPoint?.accessPointId
      ) {
        currentUnit.accessPointName =
          this.formGroup?.value.deviceNameDetails.deviceName;
      }
    });
    this.stateManagementService.updateUnits(floorId, units);
  }

  getAllPartnerDevices(): void {
    this.floorManagementService
      .getPartnerDevicesByAccessPoint(this.accessPointId)
      .subscribe();
  }
}
